export default __webpack_public_path__ + "static/media/person1.e9736f38.png";